import React from 'react'
import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3)
    },
}));
/**
 * Make Money on Versa page displays information how Versa can help vendors
 *
 * @component
 */
function MakeMoneyOnVersaPage() {
    const classes = useStyles();
    // const history = useHistory();

    return (
        <Container component="main" maxWidth="md" className = {classes.root}>
            <h3>Make Money on Versa</h3>
            <hr />
            <p>Coming soon...</p>
            <hr />
        </Container>
    )
}

export default MakeMoneyOnVersaPage
